<template lang="pug">
  #hamburger.hamburger(:class="{open: open, dark: dark}" @click="$emit('click')")
    .patties
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
$width: 34px;
$height: 5px;

.hamburger {
  display: block;
  position: absolute;
  top: 30px;
  right: 45px;
  width: $width;
  height: auto;
  pointer-events: all;

  @media #{$mobile} {
    position: fixed;
    top: 19px;
    left: 20px;
    right: auto;
  }

  .patties {
    position: relative;
    width: 100%;
    padding-top: 35%;
  }

  &:before, &:after {
    position: relative;
    content: '';
    display: block;
    left: 0;
    height: 5px;
    width: 35px;
    margin: 0;
    background: $cream;
    transition: transform 300ms linear, top 300ms linear, background 400ms 400ms linear;
    transform-origin: left;

    @media #{$mobile} {
      width: 32px;
      height: 4px;
      transition: transform 0.3s ease;
      background: $black;
    }
  }

  &:before {
    top: 0%;
    transform: rotate(-0deg);
  }

  &:after {
    bottom: 0%;
    transform: rotate(0deg);
  }

  &:hover {
    cursor: pointer;
  }

  &.dark {
    &:before, &:after {
      background: $black;
    }
  }

  &.open {
    transform: translateX(0);
    transition: transform linear, top linear;

    @media #{$mobile} {
      top: 16px;
      // left: 26px;
    }

    &:before, &:after {
      background: $black;
    transition: transform 300ms linear, top 300ms linear, background 400ms linear;
    }

    &:before {
      top: -4px;
      left: $width / 8;
      transform: rotate(45deg);

      @media #{$mobile} {
        left: 0;
        top: -3px;
      }
    }

    &:after {
      bottom: -4px;
      left: $width / 8;
      transform: rotate(-45deg);

      @media #{$mobile} {
        left: 0;
      }
    }
  }

}
</style>
